import DOMPurify from 'dompurify'

/**
 * Sanitize HTML string to prevent XSS attacks.
 * Only allows safe tags and attributes.
 */
export function sanitizeHtml (dirty) {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty)
}
